import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './Catalog.css';
import CatalogSidebar from '../../components/CatalogSidebar';
import CatalogDetail from '../../components/CatalogDetail';
import BreadcrumbCatalog from '../../components/BreadcrumbCatalog';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';
import { StickyContainer, Sticky } from 'react-sticky';
import classnames from 'classnames';
import ScrollableAnchor, { goToAnchor } from 'react-scrollable-anchor';
import { isMobile } from '../../lib/util';

let lastQueryStr = "";

class Catalog extends Component {
  constructor() {
    super();
    this.state = {
      modalActive: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      modalActive: !this.state.modalActive,
    });
  }

  goToAnchorResults() {
    if(isMobile()){
      const queryStr = this.props.location.pathname;
      
      if(queryStr && lastQueryStr !== queryStr){
        setTimeout( () => goToAnchor('catalog'), 300);
        lastQueryStr = queryStr;
      }
    }
  }

  componentDidMount() {
    this.goToAnchorResults();
  }

  componentDidUpdate() {
    this.goToAnchorResults();
  }

  render() {
    return (
      <section className="section">
        <ScrollToTopOnMount />
        <ScrollableAnchor id="catalog">
          <div className="catalog container">
            <BreadcrumbCatalog categories={this.props.categories} {...this.props} />
            <div className="outter-container">  
              <StickyContainer className="inner-container">
                <div className="columns">
                  <div className="column is-hidden-tablet">
                    <Sticky>
                      {
                        ({
                          style,
                          isSticky 
                        }) => {
                          return (
                            <div className={classnames({
                              "mobile-catalog-filter": true,
                              "is-sticky": isSticky
                            })} style={{
                              ...style,
                              top: isSticky ? "64px" : 0
                            }}>
                              <button className="button is-primary" onClick={this.toggleModal}>
                                產品篩選
                              </button>
                            </div>
                          )
                        }
                      }
                    </Sticky>
                  </div>
                  <Route
                    path="/catalog"
                    render={props => (
                      <CatalogSidebar
                        categories={this.props.categories}
                        products={this.props.products}
                        extraClass="is-hidden-mobile"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/catalog"
                    render={props => (
                      <CatalogDetail
                        categories={this.props.categories}
                        products={this.props.products}
                        {...props}
                      />
                    )}
                  />
                </div>
              </StickyContainer>
            </div>
          </div>
        </ScrollableAnchor>
        {/* modal */}
        <div className={`modal ${this.state.modalActive ? 'is-active' : ''}`}>
          <div className="modal-background" />
          <div className="modal-content">
            <div className="card card-mobile-catalog">
              <div className="card-content">
                <Route
                  path="/catalog"
                  render={props => (
                    <CatalogSidebar
                      categories={this.props.categories}
                      products={this.props.products}
                      toggleMobileModal={this.toggleModal}
                      {...props}
                    />
                  )}
                />
              </div>
            </div>
          </div>
          <button
            className="modal-close is-large"
            aria-label="close"
            onClick={this.toggleModal}
          />
        </div>
      </section>
    );
  }
}

Catalog.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = state => ({
  categories: state.categories,
  products: state.products,
});

export default connect(mapStateToProps)(Catalog);



// WEBPACK FOOTER //
// ./src/containers/page/Catalog.js